import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb', // Use a more vibrant color
    },
    secondary: {
      main: '#4caf50',
    },
    background: {
      default: '#f5f7fa', // Light background color
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h3: {
      fontSize: '3rem',
      '@media (max-width: 600px)': {
        fontSize: '1.75rem',
      },
    },
    h4: {
      fontSize: '2.125rem',
      '@media (max-width: 600px)': {
        fontSize: '1.5rem',
      },
    },
    h5: {
      fontSize: '1.5rem',
      '@media (max-width: 600px)': {
        fontSize: '1.2rem',
      },
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2563eb',
          color: '#fff',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          color: '#1e293b',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: '12px',
          borderRadius: '8px',
          '@media (min-width: 600px)': {
            padding: '16px',
          },
        },
      },
    },
    // Card is built on Paper but almost always composes CardHeader / CardContent
    // which have their own padding. The global Paper padding above leaves a
    // border around the CardHeader colored strip — override to 0 so headers
    // fill edge-to-edge. sx `p: 0` on individual Cards couldn't win against
    // the styleOverride selector specificity.
    MuiCard: {
      styleOverrides: {
        root: {
          padding: 0,
          '@media (min-width: 600px)': {
            padding: 0,
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '12px',
          paddingRight: '12px',
          '@media (min-width: 600px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
        },
      },
    },
  },
});

export default theme;
